import React,{useState, useEffect} from 'react';
import ScheduleBody from './ScheduleBody';

export default function Schedule(param) {

    const [sideCheck, setSideCheck] = useState(true);

    function callbackSideBarCheck() {
        setSideCheck(!sideCheck);
    }

    return(
        <div >
            {/* <Header callbackSideBarCheck={callbackSideBarCheck}/> 사용안해서 주석처리함. sidebar  열고 접는 버튼과 연동 */}
            <ScheduleBody type={param.match.params.type} projectId={param.match.params.projectId} programId={param.match.params.programId} sideCheck={sideCheck}/>
        </div>


    );
}